import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import api from "@/lib/api";
import { HOME_STORE, useMall } from "@/context/MallContext";

/**
 * The shop a page is standing in: `?store=` on the link wins, then the shop already entered, then the
 * house shop — the storefront is never without a shop (Phase 10), so no page ever asks you to pick one.
 */
export function useShop() {
    const { store, shopSlug, ensureStore, enter, homeSlug } = useMall();
    const [sp] = useSearchParams();
    const param = sp.get("store");
    const slug = param || shopSlug || homeSlug || HOME_STORE;

    useEffect(() => { ensureStore(); }, [ensureStore]);
    useEffect(() => {
        if (!slug || slug === store?.slug) return;
        api.get(`/stores/${slug}`)
            .then(({ data }) => { if (data.store) enter({ ...data.store, designers: data.store.designers_enabled }, "link"); })
            .catch(() => { });
    }, [slug, store?.slug, enter]);

    return { shopSlug: slug, store };
}

/** Put the visitor inside a shop by slug (cart, tracker, confirmation, /pay) so the header wears that shop's name. */
export function useEnterShop(slug) {
    const { store, enter } = useMall();
    useEffect(() => {
        if (!slug || slug === store?.slug) return;
        api.get(`/stores/${slug}`)
            .then(({ data }) => { if (data.store?.status === "active") enter({ ...data.store, designers: data.store.designers_enabled }, "link"); })
            .catch(() => { });
    }, [slug, store?.slug, enter]);
}
